import React from 'react';
import { useI18n } from '@whizz/react-i18n';
import { components } from 'react-select';
import type { MenuListComponentProps, OptionTypeBase } from 'react-select';

const CustomMenuWithResults: React.FC<MenuListComponentProps<OptionTypeBase, false>> = ({
  ...props
}): JSX.Element => {

  const { translate } = useI18n();

  const hasOptions = Array.isArray(props.children);
  const count = hasOptions ? React.Children.count(props.children) : 0;

  if (0 === props.options.length) {
    return <components.MenuList {...props} />;
  }

  return (
    <div>
      <components.MenuList {...props}>
        <div className={'bg-light text-muted italic py-1.5 px-5'}>
          <b>{count}</b>
          {' '}{translate('components.SELECTORS.STUDENT_SEARCH.RESULT', { count: count })}
        </div>
        {props.children}
      </components.MenuList>
    </div>
  );
};

export default CustomMenuWithResults;

